import { CSSProperties } from "react";
import { Collapse } from "antd";
import type { CollapseProps } from "antd";

export type UICollapseProps = CollapseProps & {
  sx?: Record<string, unknown>;
};

export const UICollapse = ({ sx, style, ...props }: UICollapseProps) => {
  const sxStyle = (sx ?? {}) as CSSProperties;

  return <Collapse style={{ ...sxStyle, ...(style as CSSProperties) }} {...props} />;
};
